import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import get from 'lodash.get'
import ChartProvider from '../../../charts/echarts/ChartProvider'
import ChartColorProvider from '../../../charts/echarts/ColorProvider'
import Tooltip from '../../../charts/echarts/Tooltip'
import ComponentFunnel from '../../../charts/echarts/ComponentFunnel'

function FunnelChartLayout ({ config, data }) {
  const {
    height = 400,
    colorTheme = 'primary',
    nameAccessor,
    valueAccessor,
    sort = 'descending',
    orient = 'vertical',
    gap = 0,
    funnelAlign = 'center',
    tooltip = {}
  } = config

  const chartData = useMemo(() => {
    if (!Array.isArray(data) || !nameAccessor || !valueAccessor) return []
    return data.map(row => ({
      name: get(row, nameAccessor),
      value: Number(get(row, valueAccessor)) || 0
    }))
  }, [data, nameAccessor, valueAccessor])

  return (
    <ChartColorProvider theme={colorTheme}>
      <ChartProvider height={height} loadingTemplate='pie'>
        <Tooltip
          trigger={tooltip.trigger || 'item'}
          {...(tooltip.valueFormat && { valueFormat: tooltip.valueFormat })}
        />
        <ComponentFunnel
          seriesId='funnel'
          data={chartData}
          sort={sort}
          orient={orient}
          gap={gap}
          funnelAlign={funnelAlign}
        />
      </ChartProvider>
    </ChartColorProvider>
  )
}

FunnelChartLayout.propTypes = {
  config: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired
}

export default FunnelChartLayout
